export const API_ROOT = `${process.env.API}/parkpass`;
